import React from 'react';
import { Button, ButtonGroup, Modal } from '@ver-uds/react';
import { unlinkUserAccount } from '../../../utils/dashboardUtils';

export type DashboardUnlinkModalProps = {
  isOpen: boolean;
  setIsOpen: (show: boolean) => void;
  selectedUser: string;
};

const DashboardUnlinkModal = ({ isOpen, setIsOpen, selectedUser }: DashboardUnlinkModalProps): JSX.Element => {
  // Set modal's app element
  if (!document.getElementById('root')) {
    const root = document.createElement('div');
    root.id = 'root';
    document.body.appendChild(root);
    Modal.setAppElement('#root');
  }

  const onClose = (): void => {
    setIsOpen(false);
  };

  const hideUserAccount = (): void => {
    unlinkUserAccount(selectedUser);
    onClose();
  };

  return (
    <>
      <Modal
        id="remove-user-account-modal"
        header="Are you sure you want to hide this existing user account?"
        open={isOpen}
        close={onClose}
      >
        <Modal.Content>
          <p>
            The user account with User ID <strong>{selectedUser}</strong> will no longer be visible in your view of
            existing accounts. You or another person with the credentials could still link it at a later time using the
            &quot;Add User Account&quot; button.
          </p>
        </Modal.Content>
        <Modal.Footer>
          <ButtonGroup>
            <Button type="button" variant="secondary" onClick={() => setIsOpen(false)}>
              Cancel
            </Button>
            <Button type="button" variant="primary" onClick={() => hideUserAccount()}>
              Yes, Hide User Account
            </Button>
          </ButtonGroup>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DashboardUnlinkModal;
